import React from 'react';
import { Link, graphql, navigate, withPrefix } from 'gatsby';
import Layout from '../components/Layout';
import Newsletter from '../components/Newsletter';
import Footer from '../components/Footer';
import Navigation from '../components/Navigation';
import PropTypes from 'prop-types'
import ReactMarkdown from "react-markdown";
import Helmet from 'react-helmet';

const PressPage = ({ pageContext: { locale }, ...props }) => {
  const { node: data } = props.data.PressPageData.edges[0]
  return (
    <Layout>
      <Helmet>
          <html lang={locale === 'en' ? 'en' : 'de'} />
            <title>
              { 
                locale === 'en' ?
                  'Press - presono' :
                  'Presse - presono'
              }
            </title>
            <meta
              name="description"
              content={ 
                locale === 'en' ?
                  'Here you can find press release from and about presono' :
                  'Hier finden Sie Presseaussendungen von und über presono.'
              }
            />
        </Helmet>
      <Navigation langSwitch={data.frontmatter.langSwitch} locale={locale} />
      <section className="solutions press">
        <section className="headliner starfield t2 b1 pusher">
          <div className="container">
            <div class="column">
            <ReactMarkdown source={data.frontmatter.pressHeadline} />
              <p>
              {data.frontmatter.pressHeadlineSubtext}
              </p>
            </div>
          </div>
        </section>
        <section className="cards">
          <div class="container">
            <div class="columns top">


            <div className="column is-4">
            <a rel="noopener noreferrer" target="_blank" href="https://www.ots.at/presseaussendung/OTS_20200312_OTS0017/linzer-start-up-hilft-unternehmen-in-corona-krise-bild">
      <div className="card">
        <div className="card-image">
          <a target="_blank" href="https://www.ots.at/presseaussendung/OTS_20200312_OTS0017/linzer-start-up-hilft-unternehmen-in-corona-krise-bild">
            <figure className="image is-4by3">
              <img src={withPrefix('/img/presse.jpeg')} alt="Presse Aussendung" />
            </figure>
          </a>
        </div>
        <div className="card-content">
          <div className="media">
            <div className="media-content">
              <p className="title is-4">Presse Aussendung</p>
            </div>
          </div>
          <div className="content">
            <p>
            Linzer Start-up hilft Unternehmen in Corona-Krise
              <br />
            </p>
            <time dateTime="2016-1-1">12.03.2020</time>
              <div class="circle-ar">
                <div class="icon-ar">
                  <div class="arrow"></div>
                </div>
              </div>
          </div>
        </div>
      </div>
            </a>
    </div>


              <div className="column is-4">
                      <a rel="noopener noreferrer" target="_blank" href="https://www.ots.at/presseaussendung/OTS_20190723_OTS0009/so-revolutionaer-koennen-ab-sofort-alle-praesentieren-bild">
                <div className="card">
                  <div className="card-image">
                    <a target="_blank" href="https://www.ots.at/presseaussendung/OTS_20190723_OTS0009/so-revolutionaer-koennen-ab-sofort-alle-praesentieren-bild">
                      <figure className="image is-4by3">
                        <img src={withPrefix('/img/presse-presono.png')} alt="Presse Aussendung" />
                      </figure>
                    </a>
                  </div>
                  <div className="card-content">
                    <div className="media">
                      <div className="media-content">
                        <p className="title is-4">Presse Aussendung</p>
                      </div>
                    </div>
                    <div className="content">
                      <p>
                        So revolutionär können ab sofort alle präsentieren!
                        <br />
                      </p>
                      <time dateTime="2016-1-1">23.07.2019</time>
                        <div class="circle-ar">
                          <div class="icon-ar">
                            <div class="arrow"></div>
                          </div>
                        </div>
                    </div>
                  </div>
                </div>
                      </a>
              </div>
              <div className="column is-4">
              <Link to={ locale === "en" ? "/contact" : "/de/contact" }>
                <div className="card">
                  <div className="card-image">
                    <figure className="image is-4by3">
                      <img src={withPrefix('/img/Share.jpg')} alt="Presse Aussendung" />
                    </figure>
                  </div>
                  <div className="card-content">
                    <div className="media">
                      <div className="media-content">
                        <p className="title is-4">Presse Kontakt</p>
                      </div>
                    </div>
                    <div className="content">
                      Julia Kurbatfinsky I +43(0) 660 225 51 77<br />office@kurbatfinsky.at
                      <time datetime="2016-1-1">10.01.2018</time>
                      
                        <div class="circle-ar">
                          <div class="icon-ar">
                            <div class="arrow"></div>
                          </div>
                        </div>
                      
                    </div>
                  </div>
                </div>
                </Link>
              </div>

            </div>
          </div>
        </section>
        <section class="downloads">
          <div class="container">
            <div class="inner-container">
              <div class="spacer">
                <section className="headliner starfield t4 pusher">
                  <div class="column">
                    <h2>
                    <span class="underline">Downloads</span>
                    </h2>
                    <p>
                    
                    </p>
                  </div>
                </section>
                <div className="columns">

                
                  <div className="column is-one-third">
                          <a target="_blank" href="/Logos.zip">
                    <div className="card">
                      <div className="card-content">
                        <div className="media">
                          <div className="media-content">
                            <p className="title is-4">Logos</p>
                          </div>
                        </div>
                        <div className="content">
                          Zum Download steht sowohl die farbige Variante also auch schwarz und weiß.<br />
                          Verfügbar als .eps, .png und .pdf.
                            <div class="circle-ar">
                              <div class="icon-ar">
                               <div class="arrow-down"></div>
                              </div>
                            </div>
                        </div>
                      </div>
                    </div>
                          </a>
                  </div>
                  <div className="column is-one-third">
                    <a target="_blank" href="/Presseinfo_presono.pdf">
                    <div className="card">
                      <div className="card-content">
                        <div className="media">
                          <div className="media-content">
                            <p className="title is-4">EPK</p>
                          </div>
                        </div>
                        <div className="content">
                          Elektronisches Pressekit inklusive Firmenbeschreibung, Kurzinterviews, uvm.
                            <div class="circle-ar">
                              <div class="icon-ar">
                                <div class="arrow-down">
                                </div>
                              </div>
                            </div>
                        </div>
                      </div>
                    </div>
                    </a>
                  </div>

                  <div className="column is-one-third">
                    <a target="_blank" href="/Linzer_Start-up_presono_hilft_Unternehmen_in_Corona-Krise.zip">
                    <div className="card">
                      <div className="card-content">
                        <div className="media">
                          <div className="media-content">
                            <p className="title is-4">Linzer Startup</p>
                          </div>
                        </div>
                        <div className="content">
                        presono hilft Unternehmen in Corona-Krise
                            <div class="circle-ar">
                              <div class="icon-ar">
                                <div class="arrow-down">
                                </div>
                              </div>
                            </div>
                        </div>
                      </div>
                    </div>
                    </a>
                  </div>


                </div>
              </div>
            </div>
          </div>
        </section>
      </section>
      <Newsletter newsletter={data.frontmatter} locale={locale} />
      <Footer locale={locale} />
    </Layout>
  );
};

export default PressPage;

PressPage.propTypes = {
  data: PropTypes.shape({
    allMarkdownRemark: PropTypes.shape({
      edges: PropTypes.array,
    }),
  }),
}

export const pageQuery = graphql`
query PressContent($locale: String) {
  PressPageData: allMarkdownRemark(
    filter: {frontmatter: { pageKey: {eq: "page_press"}, locale: { eq: $locale }}}
  ) {
    edges {
      node {
        fields {
          slug
        }
        frontmatter {
          pageKey
          pressHeadline
          pressHeadlineSubtext
          langSwitch
        }
      }
    }
  }
}
`;
